// Central re-export of socket-related hooks and helpers
export { default as useSocketConnection } from './useSocketConnection';
export { default as useSocketEvent } from './useSocketEvent';
export * from './socketUtils';
export {
  pauseSocketEvent,
  resumeSocketEvent,
  isSocketEventPaused,
  addSocketListener,
  emitSocketEvent,
  getSocket,
} from './socketHelpers';
export {
  isValidSocketEvent,
  isEventPaused,
  isEventEnabled,
  pauseEvent,
  resumeEvent,
  disableEvent,
  enableEvent,
} from './socketManager';
export { default as SOCKET_EVENTS } from './socketEvents';
export { default as SOCKET_NOTIFICATION_TEMPLATES } from './socketNotificationTemplates';
export {
  default as socketNotificationHelpers,
  presentSocketNotification,
  getTemplateForEvent,
  playSoundIfNeeded,
} from './socketNotificationHelpers';
